import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { useCurrentUserId } from "../lib/useCurrentUserId";
import { useIsHomeHealthEnabled } from "../lib/useIsHomeHealthEnabled";
import { HOME_HEALTH_CASES_PATH } from "./paths";

const CasesPage = lazy(
  async () =>
    await import("./CasesPage").then((module) => ({
      default: module.CasesPage,
    }))
);

export function HomeHealthProtectedCasesPage() {
  const currentUserId = useCurrentUserId();
  const isLoggedIn = isDefined(currentUserId);
  const isHomeHealthEnabled = useIsHomeHealthEnabled();

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", `/v2/home/${HOME_HEALTH_CASES_PATH}`);
    return <Redirect to={`/enter?requestedUrl=v2/home/${HOME_HEALTH_CASES_PATH}`} />;
  }

  if (!isHomeHealthEnabled) {
    localStorage.removeItem("redirectURL");
    return <Redirect to="/" />;
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <CasesPage />
    </Suspense>
  );
}
